import React, { Component } from 'react';

class VisibilityToggle extends Component {
  componentDidMount() {
    let visible = true;
    this.keydownListener = document.addEventListener('keydown', event =>  {
      if (event.key === '+') {
        visible = !visible;
        this.props.onChange(visible);
      }
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownListener);
  }

  render() {
    return <a style={{cursor:'pointer'}} onClick={event => this.props.onChange(!this.props.visible)}>[{this.props.visible ? '-' : '+'}]</a>
  }
}

export default VisibilityToggle;




// WEBPACK FOOTER //
// ./src/VisibilityToggle.js